import { cn } from 'component-library';

export type CalendarProps = {
  id?: string;
  name: string;
  onChange?: (date: string | null) => void;
  value?: string | null;
  placeholder?: string;
  className?: string;
  max?: string;
  min?: string;
};

export const Calendar = ({ id, name, onChange, value, placeholder, className, max, min }: CalendarProps) => {
  const showPlaceholder = !value && placeholder;

  return (
    <div className='relative w-full'>
      <input
        type='date'
        id={id}
        name={name}
        onChange={(e) => onChange?.(e?.target?.value || null)}
        value={value || ''}
        placeholder={placeholder}
        className={cn(
          'w-full pr-6 pl-4 py-2 rounded-xl border border-neutral-black-12 bg-white-100',
          'text-text-primary typography-body2',

          'focus:outline-none focus:border-primary-100',
          'hover:border-primary-100 hover:cursor-pointer transition-colors duration-100',

          // Styles for the calendar icon
          '[&::-webkit-calendar-picker-indicator]:absolute [&::-webkit-calendar-picker-indicator]:right-2',
          '[&::-webkit-calendar-picker-indicator]:top-1/2 [&::-webkit-calendar-picker-indicator]:-translate-y-1/2',
          '[&::-webkit-calendar-picker-indicator]:w-5 [&::-webkit-calendar-picker-indicator]:h-5',
          '[&::-webkit-calendar-picker-indicator]:cursor-pointer',
          '[&::-webkit-calendar-picker-indicator]:opacity-60 [&::-webkit-calendar-picker-indicator]:hover:opacity-100',

          // Styles for empty value
          !value && !placeholder && 'text-text-disabled',
          showPlaceholder &&
            'text-transparent [&::-webkit-datetime-edit-fields-wrapper]:opacity-0 [&::-webkit-datetime-edit-text]:opacity-0 [&::-webkit-datetime-edit]:opacity-0',
          className,
        )}
        max={max}
        min={min}
      />
      {showPlaceholder && (
        <span className='absolute left-4 top-1/2 -translate-y-1/2 text-text-disabled pointer-events-none'>
          {placeholder}
        </span>
      )}
    </div>
  );
};
